export default {
    mark_as_rma_title: "Marcar como RMA",
    mark_as_rma_input: "IMEI o serie",
    mark_as_rma_imei: "IMEI",
    mark_as_rma_serial: "Serie",
    mark_as_rma_model: "Modelo",
    mark_as_rma_change: "Cambiar",
    mark_as_rma_no_devices_added: "No se han añadido dispositivos",
    mark_as_rma_device_is_already_added: "El dispositivo ya está añadido",
    mark_as_rma_device_has_not_been_found: "No se ha encontrado el dispositivo",
    mark_as_rma_this_feature_is_not_available: "Esta función no está disponible",
    mark_as_rma_single_success_message: "El dispositivo ha sido marcado como RMA",
    mark_as_rma_multiple_success_message: "Los dispositivos han sido marcados como RMA",
    mark_as_rma_error_message: "No se puede marcar como RMA debido a un error",
    mark_as_rma_show_in_web: "Mostrar en la Web",
    mark_as_rma_number: "Número RMA",
    mark_as_rma_device_is_already_rma: "El dispositivo ya está marcado como RMA",
    mark_as_rma_device_is_already_refirbished: "El dispositivo ya está remanufacturado",
    mark_as_rma_devices_is_already_rma: "Hay dipositivos que ya estan marcados como RMA",
    mark_as_rma_devices_is_already_refirbished: "Hay dispositivos que ya fueron remanufacturados",
    mark_as_rma_min_message: "El número RMA debe tener al menos 5 digitos",
    mark_as_rma_transaction_message: "La solicitud para marcar los dispositivos como RMA ha sido enviada con éxito, por favor revise la lista de transacciones para ver el estado de la solicitud.",
}